import Snappy from '../../../libs/snappy/snappy';
import Handlebars from 'handlebars';

Snappy.Component.LiveScores = class LiveScores extends Snappy.BaseComponent {
	static get tagName() {
		return 'fa-live-scores';
	}
	
	constructor(element) {
		super(element);
	}
	
	render() {
		this.setVars();
		this.setEventListeners();
		this.loadOptaData();
	}
	
	setVars() {
		this.onOptaDataReceived = this.onOptaWidgetRendered;
		this.$carouselComponent = this.$element.find('.fa-carousel');
		this.$carousel = this.$carouselComponent.find('.carousel');
		this.fixtureTemplate = this.$element.find('#carousel-slide').html();
		this.$tournamentSelect = this.$element.find('.fa-dropdown__select');
		this.optaTemplate = this.$element.find('#opta-template-scores');
		this.$scoresPlaceholder = this.$element.find('.live-scores-placeholder');
		this.componentLoadingClass = 'fa-live-scores--loading';
		this.componentErrorClass = 'fa-live-scores--error';
	}
	
	setEventListeners() {
		this.$tournamentSelect.on('change', this.onTournamentChange.bind(this));
	}
	
	onOptaWidgetRendered(event, isError) {
		if (this.isLoadingData) {
			this.setOptaVars();
			this.injectFixturesIntoCarousel();
			this.activeOptaWidget = this.$scoresPlaceholder.find('div').attr('id');
			this.$element.removeClass(this.componentLoadingClass);
			this.destroyOriginalWidget();
			this.isLoadingData = false;
			
			if (isError) {
				this.onDataError();
				return;
			}
			
			if (!this.carouselInitialized) {
				this.initCarousel();
			}
		}
	}
	
	setOptaVars() {
		this.$opta = this.$element.find('.Opta');
		this.$optaFixtures = this.$opta.find('.Opta-fixture');
	}
	
	injectFixturesIntoCarousel() {
		this.compiledFixtures = this.$optaFixtures.map((i, fixture) => {
			return this.fixtureTemplate.replace('<%fixture%>', fixture.outerHTML);
		});
		const markup = Array.prototype.slice.call(this.compiledFixtures).join('');
		this.$carousel.append(markup);
	}

	destroyOriginalWidget() {
		const optaInstance = Opta.widgets[this.activeOptaWidget];
	
		if (optaInstance) {
			optaInstance.destroy(true);
		}
	}

	initCarousel() {
		const carouselInstance = this.$carouselComponent.get(0).component;
		this.$carousel.slick(carouselInstance.options);
		this.carouselInitialized = true;
	}

	onTournamentChange() {
		if (this.carouselInitialized) {
			this.carouselInitialized = false;
			this.$carousel.slick('unslick');
			this.$carousel.empty();
		}
	
		this.loadOptaData();
	}

	setDataTimeout() {
		this.dataTimeout = window.setTimeout(this.cancelDataCall.bind(this), 600000);
	}

	cancelDataCall() {
		if (this.isLoadingData) {
			this.isLoadingData = false;
			this.$element.removeClass(this.componentLoadingClass);
			this.onDataError();
		}
	}

	loadOptaData() {
		const optaCompetitionId = this.$tournamentSelect.val();
		const optaCompetitionSeason = this.$tournamentSelect.find(`option[value="${optaCompetitionId}"]`).data('season');
		const context = {
			optaCompetitionId,
			optaCompetitionSeason
		};
		const template = Handlebars.compile(this.optaTemplate.html());
		this.$element.addClass(this.componentLoadingClass);
		if (this.dataTimeout) {
			window.clearTimeout(this.dataTimeout);
		}
		let html = template(context);
		html = html.replace('load="false"', '');
		
		this.$element.removeClass(this.componentErrorClass);
		this.isLoadingData = true;
		this.$scoresPlaceholder.append(html);
		this.resumeOpta();
		this.setDataTimeout();
	}

	resumeOpta() {
		if (window.Opta) {
			window.Opta.start();
		}
	}

	onDataError() {
		this.$element.addClass(this.componentErrorClass);
	}
};



// WEBPACK FOOTER //
// ./components/liveScores/scripts/liveScores.js